import { React, useRef, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import moment from 'moment';
import { formatPhoneNumber } from '../../../Utils/phoneUtils';
import UserProfile from '../../../Component/Normal/UserProfile';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

export default function NewWaittingMemberInfo(props){
  const { data, index, isHover, isIgnore, isUsePaymentSystem, onClickedAgree, onClickedIgnore } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const history = useHistory();

  const [isLinkPayHover, setIsLinkPayHover] = useState(false);
  const [isLinkPay, setIsLinkPay] = useState(false);
  const [gender, setGender] = useState('');
  const [birth, setBirth] = useState('');
  const [memberShip, setMemberShip] = useState('-');


  const WrapperRef = useRef();
  const RegistrationRef = useRef();
  const WarningRef = useRef();

  // 데이터 정리 //
  useEffect(() => {
    let gender = '';

    if (data.birthDay[7] === '1') gender = t('waiting.male');
    else if (data.birthDay[7] === '2') gender = t('waiting.female');
    else if (data.birthDay[7] === '3') gender = t('waiting.male');
    else if (data.birthDay[7] === '4') gender = t('waiting.female');

    // if (data.memberShip === undefined) setMemberShip('-');
    setGender(gender);
    const linkPayFlag = data.merchantUid.split('-')[2] === '1';
    setIsLinkPay(linkPayFlag);
  }, [data])

  // 회원 정보 클릭시 //
  function onClickWaitingMember(e) {
    if (WarningRef.current.contains(e.target) || RegistrationRef.current.contains(e.target) || WrapperRef.current.contains(e.target)) return;
    
    if (data.memberId === -1) {
      alert(t('waiting.notRegistered'));
      return;
    }

    window.open('/member/valid/detail/' + data.memberId, '_blank');
  }

  // 회원 전화번호 이쁘게 정리 //
  function calcUserPhone() {
    return data.phone.slice(0, 3) + '-' + data.phone.slice(3, 7) + '-' + data.phone.slice(7, 11);
  }

  // 등록버튼에 마우스 올라갈 경우 //
  function onMouseOverRegistButton() {
    if (isIgnore) WrapperRef.current.style.backgroundColor = theme.subKeyAlpha50;
    else {
      if (isUsePaymentSystem && isLinkPay && data.isUseLinkPay) WrapperRef.current.style.backgroundColor = theme.subKeyAlpha50;
      else WrapperRef.current.style.backgroundColor = theme.primaryAlpha50;
    }
    RegistrationRef.current.style.opacity = '1';
    WarningRef.current.style.opacity = '0';
  }

  // 등록버튼에 마우스를 땔 경우 //
  function onMouseLeaveRegistButton() {
    WrapperRef.current.style.backgroundColor = theme.subBackground;
    RegistrationRef.current.style.opacity = '1';
    WarningRef.current.style.opacity = '1';
  }

  // 거절버튼에 마우스 올라갈 경우 //
  function onMouseOverWarningButton() {
    WrapperRef.current.style.backgroundColor = theme.pointRedAlpha50;
    RegistrationRef.current.style.opacity = '0';
    WarningRef.current.style.opacity = '1';
  }

  // 거절버튼에 마우스를 땔 경우 //
  function onMouseLeaveWarningButton() {
    WrapperRef.current.style.backgroundColor = 'transparent';
    RegistrationRef.current.style.opacity = '1';
    WarningRef.current.style.opacity = '1';
  }

  // 버튼 텍스트 결정 //
  function decideButtonText() {
    if (isIgnore) return t('waiting.reRegister');
    else {
      if (isUsePaymentSystem && isLinkPay && data.isUseLinkPay) return t('waiting.paymentRequestsButton');
      else return t('waiting.onSitePayment');
    }
  }

  // 버튼 색상 결정 //
  function decideButtonBackgroundColor() {
    if (isIgnore) return theme.subKey;
    else {
      if (isUsePaymentSystem && isLinkPay && data.isUseLinkPay) return theme.subKey;
      else return theme.primary;
    }
  }

  // 등록 및 재등록 클릭시 //
  function onClickAgree() {
    onClickedAgree(data.userId, index);
  }

  // 거절 및 영구삭제 클릭시 //
  function onClickWarning() {
    onClickedIgnore(data.userId, index, isIgnore);
  }

  return (
    <TopLevelWrapper onClick={onClickWaitingMember}>
      {/* <PayUserBox isHover={isLinkPayHover}>
        <Text fontFmaily='NotoSansKR-Bold' fontSize={10} color='#FFFFFF'>{t('waiting.linkPayUser')}</Text>
      </PayUserBox> */}
      <TotalWrapper isHover={isHover} $isDark={isDark}>
        {/* <LinkPayIconWrapper>
          {
            (isUsePaymentSystem && data.isUseLinkPay && isLinkPay) && <LinkPayIcon isHover={isLinkPayHover}  onMouseOver={() => setIsLinkPayHover(true)} onMouseLeave={() => setIsLinkPayHover(false)} />
          }
        </LinkPayIconWrapper> */}
        <ProfileWrapper>
          {/* <Profile src={data.profile === '' ? 'https://picture.link-zone.org/NoneImage.png' : data.profile}/> */}
          <UserProfile profile={data.profile} defaultProfile='https://picture.link-zone.org/NoneImage.png'/>
        </ProfileWrapper>
        <ComponentWrapper width={130}>
          {/* <UserInfoWrapper>
            <UserNameWrapper>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={16} color={theme.text}>{data.userName}</Text>
            </UserNameWrapper>
            <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.subText}>{gender}</Text>
          </UserInfoWrapper> */}
          <Text fontFmaily='NotoSansKR-Medium' fontSize={16} color={theme.text}>{data.userName}</Text>
          <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{{'신규 회원': t('waiting.waittingMemberInfo.newMember'), '유효 회원': t('waiting.waittingMemberInfo.validMember'), '만료 회원': t('waiting.waittingMemberInfo.expiredMemberState')}[data.memberState] || data.memberState}</Text>
        </ComponentWrapper>
        <ComponentWrapper width={80}>
          <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text}>{t('waiting.linkoId')}</Text>
          <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{data.userNickName}</Text>
        </ComponentWrapper>
        <ComponentWrapper width={130}>
          <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text}>{t('waiting.phone')}</Text>
          <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{calcUserPhone()}</Text>
        </ComponentWrapper>
        {
          !data.isMembership ?
            <ComponentWrapper width={120} height={75}>
              <ProductImage src={data.itemPicture !== '' ? data.itemPicture : 'https://picture.link-zone.org/DefaultLogo.png'} />
            </ComponentWrapper>
            :
            <ComponentWrapper width={120}>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text}>{t('waiting.previousPlan')}</Text>
              <PrevMemberShipNameWrapper>
                <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{data.prevMemberShip === undefined ? t('waiting.none') : data.prevMemberShip.name}</Text>
              </PrevMemberShipNameWrapper>
            </ComponentWrapper>
        }
        <ComponentWrapper width={120}>
          <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text}>{!data.isMembership ? t('waiting.requestedItem') : t('waiting.requestedMembership')}</Text>
          <PrevMemberShipNameWrapper>
            <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{data.itemName}</Text>
          </PrevMemberShipNameWrapper>
        </ComponentWrapper>
        <ComponentWrapper width={105}>
          <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text}>{t('waiting.registrationDate')}</Text>
          <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{moment(data.createdDate).format(t('calendarInput.fullDateFormat'))}</Text>
        </ComponentWrapper>
        <ButtonWrapper ref={WrapperRef}>
          <Button 
            ref={RegistrationRef} 
            // backgroundColor='#5BD98A'
            backgroundColor={decideButtonBackgroundColor()}
            onMouseOver={onMouseOverRegistButton}
            onMouseLeave={onMouseLeaveRegistButton}
            onClick={onClickAgree}>
            {/* <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color='#FDFCFB'>{isIgnore ? `재등록` : `결제 승인`}</Text> */}
            <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.white} align='center'>{decideButtonText()}</Text>
          </Button>
          <WarningButton
            ref={WarningRef}
            onMouseOver={onMouseOverWarningButton}
            onMouseLeave={onMouseLeaveWarningButton}
            onClick={onClickWarning}>
            <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.white} align='center'>{isIgnore ? t('waiting.permanentDelete') : t('waiting.decline')}</Text>
          </WarningButton>
        </ButtonWrapper>
      </TotalWrapper>
    </TopLevelWrapper>
  )
};

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0 0 0 5px;

  width: 1005px;
  height: 85px;

  gap: 20px;

  background: ${props => props.theme.subBackground};

  box-shadow: ${props => (props.isHover || props.$isDark) ? `` : `0px 40px 50px rgba(240, 232, 227, 0.5)`};
  border-radius: 20px;

  overflow: hidden;
  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const PayUserBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-left: 19px;

  width: 78px;
  height: 16px;

  opacity: ${props => props.isHover ? 1 : 0};
  border-top-left-radius: 4px;
  border-bottom-right-radius: 4px;

  background-color: ${props => props.theme.subKey};

  transition: all 0.3s ease-in-out;
`;

const ProfileWrapper = styled.div`
  width: 75px;
  height: 75px;

  border-radius: 20px;

  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 75px;
    height: 75px;
    object-fit: cover;
    object-position: center;
  }
`;

const LinkPayIconWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 19px;
  height: 100%;
`;

const LinkPayIcon = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 19px;
  height: 16px;

  border-top-left-radius: 16px;
  border-bottom-right-radius: 8px;
  background-color: ${props => props.isHover ? props.theme.subKey : props.theme.subKeyAlpha50};

  transition: all 0.3s ease-in-out;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start; 

  margin-left: 15px;

  width: ${props => props.width}px;
  height: ${props => props.height ? props.height + 'px' : '75px'};

  gap: 9px;

  overflow: hidden;
`;

const UserInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: baseline;

  width: 100%;

  gap: 3px;
`;

const UserNameWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  height: 23px;

  overflow: hidden;
`;

const ProductImage = styled.img`
  width: auto;
  height: 100%;

  border-radius: 10px;
  object-fit: cover;
`;

const PrevMemberShipNameWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start; 

  width: 100%;
  height: 20px;

  overflow: hidden;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-left: 15px;
  gap: 4px;

  width: 97px;
  height: 85px;

  // border-radius: 25px;
  border-radius: 16px;
  background-color: transparent;

  transition: all 0.3s ease-in-out;
`;

const Button = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 75px;
  height: 34px;

  border-radius: 25px;
  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const WarningButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 75px;
  height: 34px;

  border-radius: 25px;
  background-color: ${props => props.theme.pointRedAlpha20};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.pointRedAlpha50};
    }
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  width: 100%;

  text-align: ${props => props.align || 'left'};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;